<script module>
  export const meta = {
    title: 'Add friends',
    teaser:
      'Learn how to connect by adding friends via a profile link or joining sessions\ntogether, and how to stay updated with notifications once they add you back.',
    sort: 4,
  }
</script>

<p>
  Staying connected with your friends and receiving updates about their
  activities is crucial. This not only enhances your social experience but also
  ensures you don't miss out on any sessions they might partake in. Here, we'll
  guide you through the simple process of adding friends and enabling
  notifications to keep up with their sessions.
</p>
<h2>Two Simple Ways to Add Friends</h2>
<ol>
  <li>
    <p>
      <strong>Ask for Their Profile Link</strong>: One of the easiest ways to
      add friends is by asking them to send you their profile link. Once you
      have the link, simply click on it and you will see an "Add Friend" button.
      Just click on this button, and voila! You've sent a friend request.
    </p>
  </li>
  <li>
    <p>
      <strong>Join a Session Together</strong>: Another great way to expand your
      friend list is by joining a session together. You can either host a
      session and share the link or join a session hosted by someone else. At
      the conclusion of the session, you'll be presented with the option to add
      any of the participants as a friend. This method not only helps in making
      new friends but also in solidifying existing relationships.
    </p>
  </li>
</ol>
<h2>Enabling Notifications for Each Friend</h2>
<p>
  Once you've added someone as a friend, you'll have the option to enable
  notifications for their sessions. This feature ensures that you are always in
  the loop whenever they start a session. It’s a great way to stay connected and
  participate in sessions together.
</p>
<p>
  However, it’s important to note that you will only receive notifications if
  the friend has also added you back. This mutual connection is necessary for
  the notifications to work, ensuring that both parties are interested in
  receiving updates about each other's sessions.
</p>
